var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSaveTemplateClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 33.9 33.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:white;}.cls-2{fill:white;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22.51,12.5l-1.12-1.12a1.07,1.07,0,0,0-.74-.3H12.32a1.23,1.23,0,0,0-1.24,1.24v9.26a1.24,1.24,0,0,0,1.24,1.24h9.26a1.25,1.25,0,0,0,1.24-1.24V13.25A1.06,1.06,0,0,0,22.51,12.5Zm-2,3.94H13.42a.87.87,0,0,0-.88.87V21.8h-.22a.22.22,0,0,1-.22-.22V12.32a.22.22,0,0,1,.22-.22H13v2.53a.87.87,0,0,0,.87.88H20a.87.87,0,0,0,.88-.88V12.31l.93.94v8.33a.22.22,0,0,1-.22.22h-.22V17.31A.88.88,0,0,0,20.48,16.44Zm-.15,1V21.8H13.56V17.46ZM19.17,14V12.56a.51.51,0,0,0-.29-.46h1v2.39h-1A.51.51,0,0,0,19.17,14Zm-1-1.47V14a.51.51,0,0,0,.29.46H14.05V12.1h4.38A.51.51,0,0,0,18.14,12.56Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M17,33.9A17,17,0,1,1,33.9,17,17,17,0,0,1,17,33.9ZM17,1a16,16,0,1,0,16,16A16,16,0,0,0,17,1Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveTemplateClose);
export default __webpack_public_path__ + "static/media/save_template_close.79f5a1edd5e87241595460321f9d1738.svg";
export { ForwardRef as ReactComponent };